import { getLang, t } from '@shared/i18n';
import { Link } from 'react-router-dom';
import { CONTACT_EMAIL } from '../config';

// fonction (et non constante) : les textes suivent la langue choisie au démarrage
const faq = (): { q: string; a: string }[] => [
  {
    q: t('Mon compte est « en attente », pourquoi ?', 'My account is “pending”. Why?'),
    a: t(
      "FollowMe est réservée aux participants de nos rallyes. Après votre inscription, un organisateur valide votre compte ; vous recevez une notification dès que c'est fait. Pensez à indiquer votre prénom, votre nom et votre voiture pour être reconnu.",
      'FollowMe is reserved for participants in our rallies. After you sign up, an organiser approves your account; you receive a notification as soon as it is done. Remember to enter your first name, last name and car so that you can be recognised.',
    ),
  },
  {
    q: t('Quand puis-je voir le tracé du rallye ?', 'When can I see the rally route?'),
    a: t(
      "Le tracé est accessible le jour de l'événement, à partir de minuit, si vous avez touché « Je participe ». Avant, vous voyez le point de rendez-vous.",
      'The route is available on the day of the event, from midnight, if you have tapped “Join”. Before that, you can see the meeting point.',
    ),
  },
  {
    q: t('Je suis sorti du parcours, que faire ?', 'I have left the route. What should I do?'),
    a: t(
      "Suivez la ligne orange : FollowMe vous ramène au tracé par le chemin le plus court, sans demi-tour (ou au départ si vous ne l'avez pas encore pris). La partie du tracé sautée ne compte pas dans « Tracé suivi ». La voix vous guide aussi.",
      'Follow the orange line: FollowMe takes you back to the route by the shortest way, without U-turns (or to the start if you have not set off yet). The part of the route you skip does not count in “Route followed”. The voice guides you too.',
    ),
  },
  {
    q: t(
      "Le guidage continue-t-il si je quitte la carte ou que l'écran se verrouille ?",
      'Does guidance continue if I leave the map or the screen locks?',
    ),
    a: t(
      "Oui. Le suivi continue jusqu'à ce que vous touchiez « Terminer et enregistrer ». Si l'app est fermée en route, il reprend à sa réouverture.",
      'Yes. Tracking continues until you tap “Finish and save”. If the app is closed on the way, it resumes when you reopen it.',
    ),
  },
  {
    q: t("Je n'entends pas les instructions vocales.", 'I can’t hear the voice instructions.'),
    a: t(
      "Vérifiez le bouton 🔊 sur la carte, le volume du téléphone et le mode silencieux. En voiture, l'iPhone doit être connecté au système audio (Bluetooth ou CarPlay).",
      'Check the 🔊 button on the map, the phone volume and silent mode. In the car, the iPhone must be connected to the audio system (Bluetooth or CarPlay).',
    ),
  },
  {
    q: t('Qui voit ma position ?', 'Who can see my location?'),
    a: t(
      'Uniquement pendant un rallye (de « Ouvrir la carte et partir » à « Terminer »), et seulement les participants de cet événement et les organisateurs.',
      'Only during a rally (from “Open the map and go” to “Finish and save”), and only the participants in that event and the organisers.',
    ),
  },
  {
    q: t('Comment modifier mon nom, ma voiture ou ma plaque ?', 'How do I change my name, car or number plate?'),
    a: t("Dans l'app : Profil → Mon compte.", 'In the app: Profile → My account.'),
  },
];

export default function Support() {
  const en = getLang() === 'en';
  return (
    <div className="container narrow" style={{ paddingTop: 40 }}>
      <h1>{t('Assistance', 'Support')}</h1>
      <p className="muted">
        {en ? (
          <>
            A problem or a question? Write to us at <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>, stating
            your phone model and, if possible, including a screenshot. We usually reply within 48 hours.
          </>
        ) : (
          <>
            Un problème, une question ? Écrivez-nous à <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> en
            indiquant le modèle de votre téléphone et, si possible, une capture d'écran. Nous répondons en général sous
            48 h.
          </>
        )}
      </p>
      <h2>{t('Questions fréquentes', 'Frequently asked questions')}</h2>
      <div className="stack">
        {faq().map((f) => (
          <details key={f.q} className="card">
            <summary style={{ fontWeight: 700, cursor: 'pointer' }}>{f.q}</summary>
            <p style={{ marginTop: 10, marginBottom: 0 }}>{f.a}</p>
          </details>
        ))}
      </div>
      <h2>{t('Votre compte et vos données', 'Your account and your data')}</h2>
      <p>
        {en ? (
          <>
            Read our <Link to="/confidentialite">privacy policy</Link>. To delete your account, see{' '}
            <Link to="/suppression-compte">Delete your account</Link>.
          </>
        ) : (
          <>
            Consultez notre <Link to="/confidentialite">politique de confidentialité</Link>. Pour supprimer votre
            compte, voir <Link to="/suppression-compte">Supprimer son compte</Link>.
          </>
        )}
      </p>
    </div>
  );
}
